import { loginRequest } from "../authConfig";
import { IPublicClientApplication, AccountInfo } from "@azure/msal-browser";

export async function fetchWithAuth(
  url: string,
  msalInstance: IPublicClientApplication,
  account: AccountInfo,
  options: RequestInit = {}
) {
  const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account,
  });
  const token = response.accessToken;

  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}
